// extracted by mini-css-extract-plugin
export default {"container":"OfflineInfiniteErrorListPopup-module__container"};